export function accountingContextFromSearchParams(searchParams) {
  return {
    business_id: searchParams.get("business_id") || "",
    salon_id: searchParams.get("salon_id") || "",
  };
}

export function hasAccountingContext(context = {}) {
  return Boolean(context.business_id && context.salon_id);
}

export function accountingContextQuery(context = {}, extra = {}) {
  const params = new URLSearchParams();
  Object.entries({ ...context, ...extra }).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      params.set(key, String(value));
    }
  });
  return params;
}

export function accountingPath(path, context = {}, extra = {}) {
  const query = accountingContextQuery(context, extra).toString();
  return query ? `${path}?${query}` : path;
}
